import React from 'react';
import { motion } from 'framer-motion';
import { useCipherStore } from '../store/cipherStore';
import { analyzeText } from '../utils';

const CipherInput = () => {
  const { inputText, setInputText, processLayers, decryptLayers, isProcessing } = useCipherStore();
  
  const textAnalysis = analyzeText(inputText);
  
  const handleInputChange = (e) => {
    setInputText(e.target.value);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="cyber-border rounded-lg p-6 space-y-4"
    >
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold text-neon-cyan glow-text">Input Text</h2>
        <div className="text-sm text-gray-400">
          {textAnalysis.characters} chars | {textAnalysis.words} words
        </div>
      </div>
      
      <textarea
        value={inputText}
        onChange={handleInputChange}
        placeholder="Enter your text to encrypt or decrypt..."
        className="cyber-input w-full h-32 p-4 rounded-lg resize-none scrollbar-cyber"
        disabled={isProcessing}
      />
      
      <div className="flex flex-wrap gap-3">
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={processLayers}
          disabled={!inputText || isProcessing}
          className="cyber-button rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isProcessing ? (
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 border-2 border-neon-cyan border-t-transparent rounded-full animate-spin"></div>
              Encrypting...
            </div>
          ) : (
            '🔒 Encrypt'
          )}
        </motion.button>
        
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={decryptLayers}
          disabled={!inputText || isProcessing}
          className="cyber-button rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isProcessing ? (
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 border-2 border-neon-cyan border-t-transparent rounded-full animate-spin"></div>
              Decrypting...
            </div>
          ) : (
            '🔓 Decrypt'
          )}
        </motion.button>
        
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setInputText('')}
          disabled={!inputText || isProcessing}
          className="cyber-button rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
        >
          🗑️ Clear
        </motion.button>
      </div>
      
      {inputText && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          className="text-xs text-gray-500 bg-gray-800/50 p-3 rounded-lg"
        >
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            <div>Length: {textAnalysis.length}</div>
            <div>Words: {textAnalysis.words}</div>
            <div>Lines: {textAnalysis.lines}</div>
            <div>Entropy: {textAnalysis.entropy}</div>
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default CipherInput;
